export default __webpack_public_path__ + "images/5066d4a03d55599e2aa59445a0ad230d-weightlifting_small.webp";